import { useOAuth } from './useOAuth'

interface AlipayAuthOptions {
  appId?: string
}

const useAlipayAuth = (options: AlipayAuthOptions = {}) => {
  const { authCode, authLoading } = useOAuth({
    platform: 'alipay',
    appId: options.appId,
  })

  return {
    alipayAuthCode: authCode,
    alipayAuthLoading: authLoading,
  }
}

export default useAlipayAuth
